import React, {useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button } from "react-md";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import DialogContainer from "react-md/lib/Dialogs";
import TextField from "react-md/lib/TextFields";
import responseHandler from "responseHandler";

import { MSpinner, TippedIcon } from "components/Shared";
import { submitFeedback, getFeedback, getFeedbackCategories } from "requests/casetimelog/index.ts";

const TimeLogFeedback = (props) => {
  const [existingFeedback, setExistingFeedback] = useState(false);
  const [displayDialog, setDisplayDialog] = useState(false);
  const [fetchingCategories, setFetchingCategories] = useState(true);
  const [categories, setCategories] = useState([]);
  const [categorySelections, setCategorySelections] = useState([]);
  const [categoryComments, setCategoryComments] = useState("");

  let mounted = useRef(true);

  useEffect(() => {
    getFeedback(props.controlNumber, (feedback) => {
      if(feedback && feedback.reason && feedback.reason.reasonCodes.length){
        setExistingFeedback(true);
        props.callback();
      } else {
        setExistingFeedback(false);
        getFeedbackCategories(props.timeLogFeedback.workTypeId, (resp) => {
          setCategories(resp);
          setDisplayDialog(true);
          setFetchingCategories(false);
        }, mounted);        
      }
    }, mounted);
    return () => {
      mounted.current = false;
    };
  }, []);  

  const updateSelections = (code) => {
    let currSelection = [...categorySelections];
    currSelection.indexOf(code) === -1 ? currSelection.push(code) : currSelection.splice(currSelection.indexOf(code), 1);
    setCategorySelections(currSelection);
  };

  const CategoriesToQuestions = () => {
    return (
    <>
      <h4>Select each reason that caused the Expected Minutes to be exceeded:</h4>
      {categories.map(cat => {
        return (
          <>
            <FormControl key={cat.category} component="fieldset" style={{marginBottom: "10px"}}>
              <div><b>{cat.category}</b></div>
              <FormGroup aria-label="position" name="position" row>
                {cat.subCategories.map(subCat => {
                  let checked = categorySelections.indexOf(subCat.code) !== -1;
                  return (
                    <div style={{width: "100%", textAlign: "left", height: "24px", marginBottom: "5px"}} key={subCat.code}>                   
                      <FormControlLabel                        
                        style={{ fontSize: "6px" }}
                        value="top"
                        control={
                          <Checkbox
                            color="default"
                            checked={checked}
                            value={checked}
                            onChange={() => updateSelections(subCat.code)}
                          />}
                        label={subCat.subCategory}
                        labelPlacement="end"
                      />
                      {subCat.tooltip 
                        ? <TippedIcon
                            iconName="help"
                            tooltipText={subCat.tooltip}
                            iconClassName={"no-opt-in-edits"}
                            tooltipPopoutDirection="bottom"
                          />
                        : <div />}                                                        
                    </div>
                  );
                })}
              </FormGroup>
          </FormControl>   
          <div />
        </>                       
        );
      })}       
    </>
  );};

  const submit = () => {
    if(!submissionValid()) {
      props.makeErrorToast("Please select at least one reason, and provide a comment if reason is Other");
    } else {
      submitFeedback({
        "controlIdNumber": props.controlNumber,
        "internetUserId": 0,
        "reason": {
          "reasonComments": categoryComments,
          "reasonCodes": categorySelections
        }
      }, () => {
        setDisplayDialog(false);
        props.callback();
      }, () => {setDisplayDialog(false);}, mounted);
    }    
  };

  const submissionValid = () => {
    return categorySelections.length 
      && ((categorySelections.indexOf("VALUATION_OTHER_OTHER") !== -1 && (categoryComments.length > 0 && categoryComments.length < 1000))
        ||  categorySelections.indexOf("VALUATION_OTHER_OTHER") === -1);
  };

  if(existingFeedback){
    return (<div />);
  }

  return (    
    <DialogContainer
        id="expected-minutes-feedback-dialog"
        visible={displayDialog}
        modal
        onHide={() => setDisplayDialog(false)}
        actions={[(        
          <Button
            key="submit-feedback"
            raised
            primary
            disabled={false}
            onClick={() => submit()}>
            Submit
          </Button>)]}
        title="Expected Minutes Exceeded"
        width={600}
      >
        {fetchingCategories 
          ? <MSpinner />
          : <>
              <CategoriesToQuestions />          
              <TextField
                id="feedback-notes"
                type={"text"}
                maxLength={1000}
                label={"Comments"}
                onChange={val => setCategoryComments(val)}
                required={categorySelections.indexOf("VALUATION_OTHER_OTHER") !== -1}
                rows={3}
              />               
            </>}
    </DialogContainer>   
  );
};

TimeLogFeedback.propTypes = {
  callback: PropTypes.func,
  timeLogFeedback: PropTypes.object,
  controlNumber: PropTypes.number
};

const mapDispatchToProps = dispatch => ({
  makeErrorToast: text => {
    responseHandler.customToast(text, "error", dispatch);
  },
});

export default connect(
  null,
  mapDispatchToProps
)(TimeLogFeedback);